import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
    Grid, Typography, Container, Button, TextField,
    Select, MenuItem, FormControl, InputLabel, Dialog, DialogTitle,
    DialogContent, DialogActions, Snackbar, Alert,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
    Paper, TablePagination
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { gridSpacing } from '../../store/constant';
import { modeContext } from '../../context/modeContext';

const ProgramacionAlertas = () => {
    const theme = useTheme();
    const { token, tokenCompany, user } = React.useContext(modeContext);

    const [rows, setRows] = React.useState([]);
    const [grupoMaestros, setGrupoMaestros] = React.useState([]);
    const [negocios, setNegocios] = React.useState([]);

    const [selectedGrupoMaestro, setSelectedGrupoMaestro] = React.useState('');
    const [selectedNegocio, setSelectedNegocio] = React.useState('');
    const [filtroTexto, setFiltroTexto] = React.useState('');
    const [negociosModal, setNegociosModal] = React.useState([]);

    const [modalGrupoMaestro, setModalGrupoMaestro] = React.useState('');
    const [modalNegocio, setModalNegocio] = React.useState('');
    const [tipoMantenimiento, setTipoMantenimiento] = React.useState('');
    const [periocidad, setPeriocidad] = React.useState('');

    const [openModal, setOpenModal] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalCount, setTotalCount] = React.useState(0);
    const [filtroClienteNombre, setFiltroClienteNombre] = React.useState('');

    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });

    React.useEffect(() => {
        fetchGrupoArticuloMaestro();
        fetchGruposArticulos();
        fetchNegociosModal(); 
    }, []);
    

    const fetchNegociosModal = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API}business/api/negocios/listar-negocios-por-grupoarticulo`, {
                headers: {
                    'Content-Type': 'application/json',
                    token,
                    empresa: tokenCompany,
                    cache: 'no-cache',
                    pragma: 'no-cache',
                    'cache-control': 'no-cache'
                }
            });
            const data = await res.json();
            setNegociosModal(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error al cargar negocios para el modal:", error);
            setNegociosModal([]);
        }
    };

    
    const fetchGrupoArticuloMaestro = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API}business/api/grupo-articulo-maestro/listar-grupo-articulos-maestros`, {
                headers: {
                    'Content-Type': 'application/json', token, empresa: tokenCompany,
                    cache: 'no-cache',
                    pragma: 'no-cache',
                    'cache-control': 'no-cache'
                }
            });
            const data = await res.json();
            setGrupoMaestros(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e); setGrupoMaestros([]);
        }
    };

    const fetchNegociosPorGrupo = async (idGrupo) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API}business/api/negocios/listar-negocios-por-grupoarticulo?GrupoArticuloMaestro=${idGrupo}`, {
                headers: {
                    'Content-Type': 'application/json', token, empresa: tokenCompany,
                    cache: 'no-cache',
                    pragma: 'no-cache',
                    'cache-control': 'no-cache'
                }
            });
            const data = await res.json();
            setNegocios(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e); setNegocios([]);
        }
    };

    React.useEffect(() => {
        if (openModal && filtroClienteNombre) {
            const negocio = negocios.find(n => n.nombre === filtroClienteNombre);
            if (negocio) setModalNegocio(negocio.id);
        }
    }, [negocios]);

    const fetchGruposArticulos = async (pageInit = page, limit = rowsPerPage, filtroGrupo = selectedGrupoMaestro, filtroNegocio = selectedNegocio, texto = filtroTexto) => {
        try {
            const params = new URLSearchParams();
            params.append('page', pageInit + 1);
            params.append('limit', limit);
            if (filtroGrupo) params.append('IdGrupoArticuloMaestro', filtroGrupo);
            if (filtroNegocio) params.append('IdNegocio', filtroNegocio);
            if (texto.trim()) params.append('search', texto.trim());

            const res = await fetch(`${process.env.REACT_APP_API}business/api/grupo-articulo/listarGruposArticulos?${params}`, {
                headers: {
                    'Content-Type': 'application/json', token, empresa: tokenCompany,
                    cache: 'no-cache',
                    pragma: 'no-cache',
                    'cache-control': 'no-cache'
                }
            });
            const result = await res.json();
            setRows(result.rows.map((r, i) => ({
                id: i,
                grupoArticulo: r.GrupoArticuloMaestro?.NombreGrupoArticuloMaestro || '',
                cliente: r.TipoNegocio?.NombreNegocio || '',
                codigoCliente: r.TipoNegocio?.CodigoExterno || '',
                meses: r.MantenimientoMeses ?? ''
            })));
            setTotalCount(result.count || 0);
        } catch (e) {
            console.error(e); setRows([]); setTotalCount(0);
        }
    };

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        await fetchGruposArticulos(newPage, rowsPerPage);
    };
    
    const handleChangeRowsPerPage = async (event) => {
        const newLimit = parseInt(event.target.value, 10);
        setRowsPerPage(newLimit);
        setPage(0);
        await fetchGruposArticulos(0, newLimit);
    };

    const handleGuardar = async () => {
        if (!modalGrupoMaestro || !modalNegocio || !periocidad || !tipoMantenimiento) {
            return setSnackbar({ open: true, message: 'Completa todos los campos.', severity: 'warning' });
        }
        try {
            const res = await fetch(`${process.env.REACT_APP_API}business/api/mantenimiento-maquinarias/modificar-programacion-mantenimientos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', token, empresa: tokenCompany, usuario: user.username
                },
                body: JSON.stringify({ GrupoArticuloMaestro: modalGrupoMaestro, IdNegocio: modalNegocio, meses: parseInt(periocidad) })
            });
            const data = await res.json();
            setSnackbar({ open: true, message: data.message || 'Guardado correctamente.', severity: res.ok ? 'success' : 'error' });
            if (res.ok) {
                setOpenModal(false); fetchGruposArticulos();
            }
        } catch (e) {
            console.error(e);
            setSnackbar({ open: true, message: 'Error de conexión con el servidor.', severity: 'error' });
        }
    };

    return <Container fixed>
        <Grid container spacing={gridSpacing} alignItems="center" justifyContent="space-between">
            <Grid item>
                <Typography variant='h2' sx={{ color: theme.palette.primary.main }}>
                    Programación de Mantenimientos
                </Typography>
            </Grid>
        </Grid>

        <Grid container spacing={gridSpacing} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                    <InputLabel id="grupo-maestro-label">Grupo Artículo</InputLabel>
                    <Select labelId="grupo-maestro-label" value={selectedGrupoMaestro} label="Grupo Artículo"
                        onChange={(e) => {
                            setSelectedGrupoMaestro(e.target.value);
                            fetchNegociosPorGrupo(e.target.value);
                            setSelectedNegocio('');
                        }}>
                        {grupoMaestros.map((item) => (
                            <MenuItem key={item.id} value={item.id}>{item.nombre}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
            <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="cliente-label">Cliente</InputLabel>
                <Select
                labelId="cliente-label"
                value={selectedNegocio}
                label="Cliente"
                onChange={(e) => setSelectedNegocio(e.target.value)}
            >
                {negocios.map((item) => (
                    <MenuItem key={item.id} value={item.id}>{item.nombre}</MenuItem>
                ))}
            </Select>
            </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} display="flex" alignItems="center" gap={1}>
                <Tooltip title="Buscar">
                    <IconButton size="small" onClick={() => { setPage(0); fetchGruposArticulos(0, rowsPerPage); }}>
                        <SearchIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Reiniciar Filtros">
                <IconButton
                    size="small"
                    onClick={() => {
                        setSelectedGrupoMaestro('');
                        setSelectedNegocio('');
                        setFiltroTexto('');
                        setPage(0);
                        fetchGruposArticulos(0, rowsPerPage, '', '', '');
                    }}
                >
                    <RefreshIcon />
                </IconButton>
            </Tooltip>
            </Grid>
        </Grid>

        <Grid container spacing={gridSpacing} sx={{ mt: 2 }}>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 5 }} />
                                <TableCell align="center">Grupo Artículo</TableCell>
                                <TableCell align="center">Cliente</TableCell>
                                <TableCell align="center">Codigo Cliente</TableCell>
                                <TableCell align="center">Meses</TableCell>
                                <TableCell align="center">Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                                            <TableRow
                                            key={index}
                                            sx={{
                                                'td > p': { p: 0, m: 0 },
                                                'td, th': { px: 1, py: 0, border: 2, borderRadius: "10px", borderColor: "white" },
                                                'td': { bgcolor: "grey.200" },
                                                'th': { bgcolor: "primary.200" }
                                            }}
                                        >          
                                    <TableCell width={15} component="th"></TableCell>
                                    <TableCell align="center">{row.grupoArticulo}</TableCell>
                                    <TableCell align="center">{row.cliente}</TableCell>
                                    <TableCell align="center">{row.codigoCliente}</TableCell>
                                    <TableCell align="center">{row.meses}</TableCell>
                                    <TableCell align="center">
                                        <IconButton
                                color="primary"
                                size="small"
                                onClick={() => {
                                    const grupo = grupoMaestros.find(g => g.nombre === row.grupoArticulo);
                                    setModalGrupoMaestro(grupo?.id || '');
                                    const negocio = negociosModal.find(n => n.nombre === row.cliente);
                                    setModalNegocio(negocio?.id || '');
                                
                                    setPeriocidad(row.meses);
                                    setOpenModal(true);
                                }}
                                
                                >
                                <EditIcon />
                                </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 20]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Grid>
        </Grid>

        <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Nueva Configuración de Mantenimientos
                <IconButton onClick={() => setOpenModal(false)}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="tipo-label">Tipo</InputLabel>
                    <Select labelId="tipo-label" value={tipoMantenimiento} label="Tipo"
                        onChange={(e) => setTipoMantenimiento(e.target.value)}>
                        <MenuItem value="Preventivo">Mantenimiento Preventivo</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }} disabled>
                    <InputLabel id="grupo-maestro-modal-label">Grupo Artículo</InputLabel>
                    <Select labelId="grupo-maestro-modal-label" value={modalGrupoMaestro} label="Grupo Artículo">
                        {grupoMaestros.map((item) => (
                            <MenuItem key={item.id} value={item.id}>{item.nombre}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }} disabled>
                <InputLabel id="cliente-modal-label">Cliente</InputLabel>
                <Select labelId="cliente-modal-label" value={modalNegocio} label="Cliente">
                    {negociosModal.map((item) => (
                        <MenuItem key={item.id} value={item.id}>{item.nombre}</MenuItem>
                    ))}
                </Select>
            </FormControl>
                <TextField fullWidth label="Periocidad" type="number" value={periocidad} onChange={(e) => setPeriocidad(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
                <Button variant="contained" onClick={handleGuardar}>Guardar</Button>
            </DialogActions>
        </Dialog>

        <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
            </Alert>
        </Snackbar>
    </Container>
};

export default ProgramacionAlertas;